import './types/global'

export { SegmentAnalyticsProvider, useSegmentAnalytics, useSegmentTrackMeta } from './components/Provider'
export { PageViewed } from './components/PageViewed'
export { useStandardTrack } from './hooks/use-standard-track'
export { useTrackElementInteracted } from './hooks/use-track-element-interacted'
export { useTrackElementViewed } from './hooks/use-track-element-viewed'
export { useTrackFormStepViewed } from './hooks/use-track-form-step-viewed'
export { useTrackFormAction, type FormName } from './hooks/use-track-form-action'
export {
  buildStandardTrackPayload,
  nestNonSchemaProps,
  NW_STANDARD_EVENTS,
  EXPERIMENT_BUCKETING_SCHEMA_KEYS,
} from './standard-track'
export type { NwStandardEventMap, NwStandardTrackInputMap, NwCommonTrackProps } from './standard-track'
export { ANONYMOUS_ID_KEY, MAX_ANONYMOUS_ID_LENGTH, isValidAnonymousId } from './config'
export { type AnalyticsBrowser } from '@segment/analytics-next'
